export default __webpack_public_path__ + "static/media/solution-itnext.8922c8da.jpg";